/**
 * L2 Aetheris - API Client
 * Conecta el frontend con el backend PHP
 *
 * Por defecto, asume que el backend esta en /api del mismo dominio.
 * Si esta en otro dominio, edita REACT_APP_API_BASE en el .env
 */

const API_BASE = process.env.REACT_APP_API_BASE || '/api';

async function fetchJSON(path, params = {}) {
  const url = new URL(API_BASE + path, window.location.origin);
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null) url.searchParams.set(k, v);
  });

  try {
    const res = await fetch(url.toString(), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const json = await res.json();
    if (!json.success) throw new Error(json.error || 'API error');
    return json.data;
  } catch (err) {
    console.warn(`[API] ${path} failed:`, err.message);
    return null;
  }
}

export const api = {
  status:      ()    => fetchJSON('/status'),
  stats:       ()    => fetchJSON('/stats'),
  topPlayers:  (type = 'pvp', limit = 10) => fetchJSON('/top-players', { type, limit }),
  topClans:    (limit = 10) => fetchJSON('/top-clans', { limit }),
  castles:     ()    => fetchJSON('/castles'),
  heroes:      ()    => fetchJSON('/heroes'),
};

export default api;
